import { atom } from 'jotai';

import { stageConfigAtom } from './stageConfigAtoms';
import { powertrainAtom } from '../powertrainAtom';
import { gearIdAtom } from '../gearAtom';

// L の計算（設定の取得・送信）の対象（計算セット / powertrain / gear）を表す key。
// 描画時（useAtomValue）と応答時（store.get）で同じ定義を読めるよう派生 atom にする。
// gear は HEV のみ対象に含む（BEV では使用しない）。
export const calcTargetKeyAtom = atom((get) => {
    const { project_id, destination_id, lot_id, phase_id, calculation_id } = get(stageConfigAtom);
    const isHev = get(powertrainAtom) === 'hev';
    return [
        project_id,
        destination_id,
        lot_id,
        phase_id,
        calculation_id,
        isHev ? `hev:${get(gearIdAtom) ?? ''}` : 'bev',
    ].join('/');
});
